import { render, staticRenderFns } from "./TwoRowInfo.vue?vue&type=template&id=14dd70be&scoped=true"
import script from "./TwoRowInfo.vue?vue&type=script&lang=ts"
export * from "./TwoRowInfo.vue?vue&type=script&lang=ts"
import style0 from "./TwoRowInfo.vue?vue&type=style&index=0&id=14dd70be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14dd70be",
  null
  
)

export default component.exports